{
    "welcome": "Bienvenido",
    "getStarted": "Empezar"
}
